import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { TerminalDTO } from "../types/terminalDTO";
import { useTranslation } from 'react-i18next';
import { fi } from 'date-fns/locale';
import { registerLocale } from "react-datepicker";

registerLocale('fi', fi);

type Args = {
  headerText: string;
  terminal: TerminalDTO;
  submitted: (terminal: TerminalDTO) => void;
};

const TerminalForm = ({ headerText, terminal: initialTerminal, submitted }: Args) => {
  const { t, i18n } = useTranslation();
  const [terminalState, setTerminalState] = useState(initialTerminal);
  const nav = useNavigate();

  const onSubmit: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    submitted(terminalState);
  };

  const onCancel: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    nav(-1);
  };

  const handleNumericInputChange = (value: string) => {
    if (/^\d*$/.test(value)) { // Allow only numeric input
      setTerminalState({ ...terminalState, address: value });
    }
  };

  return (
    <div className="ml-3">
      <h5 className="subtitle text-left mb-2">{headerText}</h5>
      <form>
        {/* <div className="form-group">
          <label htmlFor="Id">Id</label>
          <input
            type="text"
            className="form-control"
            placeholder="Id"
            value={terminalState.id}
            readOnly
          />
        </div>
        <div className="form-group">
          <label htmlFor="orgId">Organisation Id</label>
          <input
            type="text"
            className="form-control"
            placeholder="Organisation Id"
            value={terminalState.organisationId}
            readOnly
          />
        </div>
        <div className="form-group">
          <label htmlFor="unitId">Unit Id</label>
          <input
            type="text"
            className="form-control"
            placeholder="Unit Id"
            value={terminalState.unitId}
            readOnly
          />
        </div> */}
        <div className="form-group">
          <label htmlFor="name">{t('common.name')}</label>
          <input
            type="text"
            maxLength={200}
            className="form-control"
            value={terminalState.name}
            onChange={(e) =>
              setTerminalState({ ...terminalState, name: e.target.value })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="address">{t('common.address')}</label>
          <input
            type="text"
            maxLength={7}
            className="form-control"
            value={terminalState.address}
            onChange={(e) => handleNumericInputChange(e.target.value)}
          />
        </div>
        <div className="form-group mt-2">
          <label htmlFor="validFrom">{t('common.validFrom')}</label>
          <div>
          <DatePicker
            className="form-control"
            dateFormat={i18n.language === 'en' ? 'yyyy-MM-dd hh:mm' : 'dd.MM.yyyy HH:mm'}
            locale={i18n.language === 'fi' ? 'fi' : 'en'}
            selected={terminalState.validFrom}
            onChange={(date: Date | null) => date && setTerminalState({ ...terminalState, validFrom: date })}
            showTimeSelect
          />
          </div>
        </div>
        <div className="form-group mt-2">
          <label htmlFor="description">{t('common.validTo')}</label>
          <div>
          <DatePicker
            className="form-control"
            dateFormat={i18n.language === 'en' ? 'yyyy-MM-dd hh:mm' : 'dd.MM.yyyy HH:mm'}
            locale={i18n.language === 'fi' ? 'fi' : 'en'}
            selected={terminalState.validTo}
            onChange={(date: Date | null) => date && setTerminalState({ ...terminalState, validFrom: date })}
            showTimeSelect
          />
          </div>
        </div>
        <button
          className="btn btn-primary mt-3 me-2"
          disabled={!terminalState.name || !terminalState.address}
          onClick={onSubmit}>
          {t('buttons.save')}
        </button>
        <button
          className="btn btn-danger mt-3"
          onClick={onCancel}>
          {t('buttons.cancel')}
        </button>
      </form>
    </div>
  );
};

export default TerminalForm;
